/**
 * The dev-tooling flag. Read in this ONE module; no other file touches
 * `import.meta.env['VITE_DEV_TOOLS']`.
 *
 * It gates dev affordances only -- the fault injector and footer (`devTools.ts`,
 * `DevToolsFooter`), the reference tenant module, the site workspace's sample series. It has no
 * say in authentication (AU-D14): with or without it, the only way in is the real sign-in.
 */
export const DEV_TOOLS = import.meta.env["VITE_DEV_TOOLS"] === "true";
